import React from 'react'
import "./Footer.css";

function Footer() {
  return (
    <nav className="navbarFooter">
   © 2025 Publicis Groupe - All Rights Reserved - Publicis CONFIDENTIAL
  </nav>
  )
}
export default Footer